<template>
  <div class="course-study-view">
    <div class="tip">
      <el-progress type="circle" :percentage="studyRate" color="#83dd69" :width="72" :stroke-width="10" title="学习进度"></el-progress>
      <div class="inline-block">
        <i class="el-icon-success"></i>正确数：<span>{{statistics.right}}</span>
        <br>
        <i class="el-icon-error"></i>错误数：<span>{{statistics.wrong}}</span>
      </div>
      <div class="inline-block used-time">
        <img :src="imgClock" alt="" class="clock" />
        <why-timer ref="timer" />
      </div>
      <div class="controls" v-if="problems && problems.length > 0 && studyIndex >= 0">
        <audio ref="audio" :src="resourceUrl + problems[studyIndex].audio" autoplay @canplaythrough="audioAutoPlay"
          @playing="audioPlayed" @pause="audioPaused" @ended="audioEnded"></audio>
        <img v-show="loading" :src="'/static/theme/' + theme + '/image/loading.gif'" alt="loading" title="加载中" />
        <img v-show="!loading" :src="'/static/theme/' + theme + '/image/' + (audioPlaying ? 'pause' : 'play') + '.png'" alt="play" @click="playClick" :title="audioPlaying ? '暂停' : '播放'" />
        <img :src="'/static/theme/' + theme + '/image/restart.png'" alt="replay" @click="reStart" title="重新开始" />
      </div>
    </div>
    <div class="options">
      <div v-for="item in currentImgs" :key="item" :class="'option-box options-' + currentImgs.length">
        <div>
          <img :src="resourceUrl + item" :name="item" @click="selectImg" draggable="false" />
          <!-- <img :src="resourceUrl + item" :name="item" @click="selectImg" :class="(studyType !== 0 ? 'option-border ' : '') + (sameName(item, problems[studyIndex].audio) ? 'show' : '')" /> -->
        </div>
      </div>
    </div>
    <transition name="fade">
      <img class="selected-img" :src="selected.imgRight" alt="正确" v-if="selected.result === 'right'" :style="{'left': selected.left + 'px', 'top': selected.top + 'px'}">
      <img class="selected-img" :src="selected.imgWrong" alt="错误" v-if="selected.result === 'wrong'" :style="{'left': selected.left + 'px', 'top': selected.top + 'px'}">
    </transition>
    <div class="hide">
      <img ref="pre_img" @load="preImgLoaded" />
      <audio ref="pre_audio" @canplaythrough="preAudioLoaded"></audio>
    </div>
    <el-dialog :visible.sync="dialogVisible" class="pop" width="500px">
      <template v-if="studyResult.passed">
        <div class="pass">恭喜，学习通过</div>
        <el-rate :colors="['red', 'red', 'red']" disabled-void-color="#D3D3D3"
          :icon-classes="['iconfont icon-flower', 'iconfont icon-flower', 'iconfont icon-flower']"
          disabled-void-icon-class="iconfont icon-flower"
          v-model="studyResult.flower" :disabled="true" :max="3">
        </el-rate>
      </template>
      <template v-else>
        <div class="unPass">很遗憾，学习未通过</div>
        <div class="unPass-text">继续努力学习，获得更多小红花吧</div>
      </template>
      <div>本次得分：<span class="score">{{studyResult.score}}</span></div>
      <div>正确率：<span class="rate">{{studyResult.rate}}%</span></div>
      <div v-if="studyResult.passed" class="mt10">
        <el-button type="text" @click="reStudy">重新学习</el-button>
        <el-button type="primary" @click="nextStudy">下一节课</el-button>
      </div>
      <div v-else class="mt10">
        <el-button type="primary" @click="reStudy">重新学习</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import whyTimer from '@/components/whyTimer'
import imgClock from 'assets/image/clock.png'
import imgRight from 'assets/image/right.png'
import imgWrong from 'assets/image/wrong.png'

export default {
  name: 'courseStudy',
  components: { whyTimer },
  data () {
    return {
      id: this.$route.params.id,
      resourceUrl: '',
      theme: window.appConfig.theme,
      imgClock,
      selected: { // 选择结果
        result: '',
        imgRight,
        imgWrong,
        left: -200,
        top: -200
      },
      audioPlaying: false, // 音频是否播放
      manualPaused: false, // 是否手动暂停
      loading: false, // 是否在加载资源
      completed: false, // 学习完成
      courseLearn: [], // 从服务器请求到的题目数据
      studyType: 0, // 课程内容形式：0 答题，1 故事，2 绘本
      problems: [],
      imgGroups: [],
      imgOrder: 0, // 图片是否随机顺序，0 顺序，1 随机
      studyIndex: -1,
      preload: { // 预加载
        imgArr: [],
        imgIndex: 0,
        audioArr: [],
        audioIndex: 0
      },
      statistics: { // 统计答题结果
        problem: 0,
        right: 0,
        wrong: 0,
        passed: 0
      },
      records: [],
      dialogVisible: false,
      studyResult: {} // 学习结果
    }
  },
  computed: {
    currentImgs () {
      if (this.problems && this.problems.length > 0 && this.studyIndex >= 0) {
        return this.imgGroups[this.problems[this.studyIndex].imgGroup]
      }
      return []
    },
    studyRate () {
      return parseInt(this.statistics.problem === 0 ? 0 : (this.statistics.passed * 100 / this.statistics.problem))
    }
  },
  created () {
    // if (!this.$store.getters.menuCollapse) {
    //   this.$store.dispatch('toggleMenu')
    // }
    this.getListens()
  },
  methods: {
    isSafari () {
      return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
    },
    getListens () {
      // 获取面包屑导航
      this.$store.dispatch('setCourseNav', {id: this.id, idType: 3})
      // 获取课程资源数据
      this.$http.get('course/learn?courseId=' + this.id)
        .then(response => {
          this.resourceUrl = window.appConfig.resourceHost + response.path + '/'
          if (response.items && response.items.length > 0) {
            this.courseLearn = response.items
            this.studyType = response.form
            this.imgOrder = response.order
            this.setProblems()
            this.$nextTick(() => {
              this.preLoad()
              this.timeStart()
            })
          } else {
            // this.$message.warning('课程资源为空')
          }
        })
        .catch(() => {
          this.$message.error('请先解锁前面的课程！')
        })
    },
    setProblems () {
      this.preload = {
        imgArr: [],
        imgIndex: 0,
        audioArr: [],
        audioIndex: 0
      }
      // 整理对象
      // this.courseLearn.shuffle() // 随机排序题目
      this.courseLearn.forEach((group, index) => {
        if (this.imgGroups.length <= index) {
          this.imgGroups.push([])
        }
        group.map(item => {
          if (item.audio.indexOf('/') === item.audio.length - 1) { return true } // 资源路径有问题
          this.preload.imgArr.push(item.img)
          this.preload.audioArr.push(item.audio)
          this.imgGroups[index].push(item.img)
          this.problems.push({
            id: item.id,
            audio: item.audio,
            imgGroup: index
          })
        })
        if (this.imgOrder === 1) {
          this.imgGroups[index].shuffle() // 图片顺序随机
        }
      })
      this.statistics.problem = this.problems.length // 题目总数
    },
    preLoad () {
      // 默默加载
      this.preImgLoaded()
      this.preAudioLoaded()
    },
    preImgLoaded () {
      // 图片资源加载完成回调，加载下一个图片
      if (this.$refs.pre_img && this.preload.imgIndex < this.preload.imgArr.length) {
        this.$refs.pre_img.src = this.resourceUrl + this.preload.imgArr[this.preload.imgIndex]
        this.preload.imgIndex++
      }
    },
    preAudioLoaded () {
      // 音频资源加载完成回调，加载下一个音频
      if (this.$refs.pre_audio && this.preload.audioIndex < this.preload.audioArr.length) {
        this.$refs.pre_audio.src = this.resourceUrl + this.preload.audioArr[this.preload.audioIndex]
        this.preload.audioIndex++
      }
    },
    timeStart (needPlay) {
      // 计时开始
      this.$refs.timer.reStart()
      // 重置为从第一题开始学习
      if (this.studyIndex !== 0) {
        this.studyIndex = 0
      } else {
        this.records = [{
          id: this.problems[0].id,
          count: 0,
          start: new Date(),
          time: 0,
          status: 'study'
        }]
        needPlay && this.replay()
      }
    },
    timeStop () {
      // 计时结束
      this.$refs.timer.stop()
    },
    sameName (img, audio) {
      if (img && audio) {
        let audioName = audio.split('.')[0]
        let imgName = img.split('.')[0]
        return audioName.toLowerCase() === imgName.toLowerCase()
      }
      return false
    },
    selectImg (e) {
      // 故事、绘本不需要选择 -> 不需要自动播放，点击过关
      // if (this.studyType !== 0) {
      //   return
      // }
      // 选择答案
      if (this.loading || this.completed) { return }
      if (this.audioPlaying) {
        this.$message.warning('请先听完再选择')
        return
      }
      let current = this.problems[this.studyIndex] // 当前题目
      if (!current.played) {
        this.$message.warning('请先听完再选择')
        return
      }
      e = e || window.event
      this.loading = true
      let record = this.records[this.studyIndex] // 学习记录
      this.selected.left = e.clientX
      this.selected.top = e.clientY
      record.count++
      record.time = new Date() - record.start // 该题用时
      if (this.sameName(e.target.name, current.audio)) {
        this.selected.result = 'right'
        this.statistics.passed++
        record.status = 'pass'
        delete record.start
        if (record.count === 1) {
          this.statistics.right++
        }
      } else {
        this.selected.result = 'wrong'
        if (record.count === 1) {
          this.statistics.wrong++
        }
      }
      setTimeout(() => {
        this.loading = false
        if (this.selected.result === 'right') {
          // 选择正确
          if (this.studyIndex + 1 === this.statistics.problem) {
            // 答题结束
            this.submit()
          } else {
            this.studyIndex++
          }
        } else {
          // 选择错误
          this.replay()
        }
        this.selected.result = ''
      }, 300)
    },
    audioAutoPlay () {
      // Safari 自动播放
      if (this.isSafari()) {
        this.$refs.audio.play()
      }
    },
    audioPlayed () {
      this.manualPaused = false
      this.audioPlaying = true
    },
    audioPaused () {
      this.audioPlaying = false
    },
    audioEnded () {
      this.audioPlaying = false
      let current = this.problems[this.studyIndex] // 当前题目
      current.played = true
      // 故事、绘本自动播放 -> 不需要自动播放，点击过关
      // if (this.studyType !== 0) {
      //   let record = this.records[this.studyIndex] // 学习记录
      //   record.count++
      //   record.time = new Date() - record.start // 该题用时
      //   this.statistics.passed++
      //   record.status = 'pass'
      //   delete record.start
      //   this.statistics.right++
      //   setTimeout(() => {
      //     if (this.studyIndex + 1 === this.statistics.problem) {
      //       // 答题结束
      //       this.submit()
      //     } else {
      //       this.studyIndex++
      //     }
      //   }, 2000)
      // }
    },
    replay () {
      try {
        if (!this.isSafari()) {
          // Safari 不需要load
          this.$refs.audio.pause()
          this.$refs.audio.load()
        }
        this.$refs.audio.currentTime = 0
        this.$refs.audio.play()
      } catch (ex) {

      }
    },
    playClick () {
      if (this.loading || this.completed) { return }
      // 播放/暂停
      if (this.audioPlaying) {
        this.manualPaused = true
        this.$refs.audio.pause()
      } else {
        // 如果是手动暂停，则继续播放
        if (this.manualPaused) {
          this.$refs.audio.play()
        } else {
          this.replay()
        }
      }
    },
    stopClick () {
      if (this.loading) { return }
      // 停止
      this.$refs.audio.pause()
      this.$refs.audio.currentTime = 0
    },
    reStart (e) {
      if (this.problems.length === 0) { return }
      let img = e && e.target
      if (img) {
        img.src = img.src.indexOf('restart.png') > 0 ? img.src.replace('restart.png', 'restart2.png') : img.src.replace('restart2.png', 'restart.png')
      }
      // 重新开始
      this.reSetData()
      this.setProblems()
      this.timeStart(true)
    },
    reSetData () {
      this.loading = false
      this.completed = false
      this.selected.result = ''
      this.statistics.problem = 0
      this.statistics.right = 0
      this.statistics.wrong = 0
      this.statistics.passed = 0
      this.problems = []
      this.imgGroups = []
      this.records = []
      this.studyResult = {}
    },
    reStudy () {
      this.dialogVisible = false
      this.reStart()
    },
    nextStudy () {
      this.dialogVisible = false
      this.$router.push({ path: '/course/study/' + this.studyResult.nextCourse })
    },
    submit () {
      this.timeStop()
      this.completed = true
      // 提交学习结果
      this.$http.post('course/record',
        {
          courseId: this.id,
          records: this.records,
          time: this.$refs.timer.getTime()
        })
        .then(response => {
          this.dialogVisible = true
          this.studyResult = response
        })
    }
  },
  watch: {
    studyIndex (newVal) {
      if (newVal >= 0 && newVal < this.problems.length) {
        this.records.push({
          id: this.problems[newVal].id,
          count: 0,
          start: new Date(),
          time: 0,
          status: 'study'
        })
      }
    },
    '$route.params.id': function (newId) {
      this.id = newId
      this.reSetData()
      this.getListens()
    }
  }
}
</script>

<style lang="scss">
.course-study-view {
  position: relative;
  height: 100%;
  min-height: 500px !important;
  .tip {
    padding: 20px 0;
    img {
      cursor: pointer;
      height: 72px;
    }
    .el-icon-success {
      color: #13CE66;
      margin-right: 5px;
    }
    .el-icon-error{
      color: #FF4949;
      margin-right: 5px;
    }
    .inline-block {
      line-height: 28px;
      vertical-align: top;
      margin: 8px 0 0 10px;
    }
    .used-time {
      margin-left: 30px;
    }
  }
  .clock {
    height: 56px !important;
    vertical-align: top;
  }
  .why-timer {
    height: 48px;
  }
  audio {
    visibility: hidden;
  }
  .controls {
    display: inline-block;
    margin-left: 120px;
    img {
      cursor: pointer;
      margin-left: 30px;
    }
  }
  .options {
    display: flex;
    flex-wrap: wrap;
    height: calc(100% - 115px);
    .option-box {
      flex-basis: 50%;
      position: relative;
      height: 400px;
      margin-top: 30px;
      div {
        position: relative;
        height: 100%;
        margin-right: 15px;
        text-align: right;
      }
      &:nth-child(even) { // 双数
        div {
          margin: 0 0 0 15px;
          text-align: left;
        }
      }
      img {
        max-width: 100%;
        max-height: 100%;
        border-radius: 20px;
        cursor: pointer;
      }
    }
    .option-border {
      border: 8px solid transparent;
      margin: -13px;
      padding: 5px;
      &.show {
        border-color: #83dd69;
      }
    }
    .options-1 {
      margin: 30px auto;
      div {
        text-align: center;
      }
    }
    .options-3 {
      flex-basis: 33.3%;
      &:nth-child(even) { // 中间
        div {
          margin: 0 15px;
          text-align: center;
        }
      }
      &:last-child {
        div {
          margin: 0 0 0 15px;
          text-align: left;
        }
      }
    }
    .options-4 {
      height: calc(50% - 30px);
    }
  }
  .selected-img {
    position: fixed;
    transform: translate(-50%, -50%);
  }
  .pop {
    text-align: center;
    .el-dialog__header {
      padding: 5px;
    }
    .pass {
      color: #83dd69;
      font-size:24px;
      animation: pass 1.5s ease-in-out infinite alternate;
    }
    .unPass {
      color: #FF4949;
      font-size: 24px;
      animation: unpass 1.5s ease-in-out infinite alternate;
    }
    .unPass-text {
      color: #212121;
      font-size: 18px;
      line-height: 80px;
    }
    .el-rate {
      height: 80px;
      line-height: 80px;
    }
    .el-rate__icon {
      font-size: 48px;
    }
    .score, .rate {
      font-size: 16px;
      font-weight: bold;
      color: #FF4949;
    }
    .el-button + .el-button {
      margin-left: 30px;
    }
  }
  @keyframes pass {
    from {
      text-shadow: 0 0 2px #FFF,
                0 0 4px  #83dd69,
                0 0 6px #83dd69;
    }
    to {
      text-shadow: 0 0 1px #FFF,
                0 0 2px #83dd69,
                0 0 3px #83dd69;
    }
  }
  @keyframes unpass {
    from {
      text-shadow: 0 0 2px #FFF,
                0 0 4px  #FF4949,
                0 0 6px #FF4949;
    }
    to {
      text-shadow: 0 0 1px #FFF,
                0 0 2px #FF4949,
                0 0 3px #FF4949;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/course/study.vue